var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.63757 0.799988H12.2001V4.36255H8.63757V0.799988Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07501 5.07501H7.92501V7.92501H5.07501V5.07501Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07501 8.63757H7.92501V12.2001H5.07501V8.63757Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.799988 5.07501H4.36255V7.92501H0.799988V5.07501Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.799988 8.63757H4.36255V12.2001H0.799988V8.63757Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.799988 0.799988H4.36255V4.36255H0.799988V0.799988Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63757 8.63757H12.2001V12.2001H8.63757V8.63757Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63757 5.07501H12.2001V7.92501H8.63757V5.07501Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07501 0.799988H7.92501V4.36255H5.07501V0.799988Z",
    fill: "#155EEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBlue);
export default __webpack_public_path__ + "static/media/grid-blue.5a0cece592b99525047f40dc9ba1196f.svg";
export { ForwardRef as ReactComponent };